<div>
    <!-- Cuentas propias -->
    <div class="col-12">
        <div class="row mb-4">
            <!-- Fecha inicio -->
            <div class="col-sm-6">
              <label for="startDate" class="form-label">Fecha Voucher</label>
              <input type="date" id="startDate" [(ngModel)]="startDate" class="form-control" />
            </div>
    
            <!-- Fecha fin -->
            <!-- <div class="col-sm-6">
              <label for="endDate" class="form-label">Fecha final</label>
              <input type="date" id="endDate" [(ngModel)]="endDate" class="form-control" />
            </div> -->

            <div class="col-sm-6">
              <label for="voucherNumber" class="form-label">No. Voucher</label>
              <input type="text" id="voucherNumber" [(ngModel)]="voucherNumber" class="form-control" />
            </div>
    
            <div class="col-sm-6">
                <label for="ownAccount" class="form-label fw-semibold">Cuenta bancaria propia</label>
                <select class="form-select" [(ngModel)]="selectedOwnAccount">
                    <option
                    *ngFor="let account of filterAccounts"
                    [ngValue]="account.accountNumber">
                    {{ account.alias }} - {{ account.accountNumber }}
                    </option>
                </select>
            </div>
            <div class="col-sm-6 d-flex align-items-end justify-content-end">
              <button class="btn btn-primary w-100" (click)="getVoucher()" [disabled]="!selectedOwnAccount || loading">
                <i class="fa fa-search" *ngIf="!loading"></i>
                <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loading"></span> Buscar
              </button>
            </div>
        </div>

        <!-- Tabla -->
    <div class="table-responsive">
        <table class="table table-hover align-middle">
            <thead class="table-light">
            <tr>
                <th>Fecha/Hora</th>
                <th>Descripción</th>
                <th>(-) Debito</th>
                <th>(+) Credito</th>
                <th>Monto Disponible</th>
            </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of pagination.total">
                    <tr>
                        <td>{{item.date}} {{item.time}}</td>
                        <td class="truncate-5-lines">
                            <div style="width: 300px;">
                                {{item.transactionDescription}}
                            </div>
                        </td>
                        <td>{{item.debitAmount | currency:"Q" }}</td>
                        <td>{{item.creditAmount | currency:"Q" }}</td>
                        <td>{{item.availableAmount | currency:"Q" }}</td>
                    </tr>
                </ng-container>
                    
            </tbody>
            </table>
        </div>

        <!-- Paginación -->
        <!-- <app-simple-pagination [elements]="paginationApplications" [sizes]="sizes" (changed)="getPaginationMovements()"></app-simple-pagination> -->
    </div>
</div>